<div class="card" [style]="style">
  <div class="card-body d-flex flex-column">
    <div class="d-flex justify-content-between mb-2">
      <div class="logo-container flex-grow-1 d-flex">
        <img *ngIf="logo" class="logo mr-3" [src]="logo">
        <h4>{{title}}</h4>
      </div>
      <div class="action-btn">
        <a class="btn btn-sm">
          <i class="icon-close" (click)="closeButton()"></i>
        </a>
        <ng-template #onCloseFunction>
          <a class="btn btn-sm" (click)="onClose()">
            <i class="icon-close"></i>
          </a>
        </ng-template>
      </div>
    </div>
    <div style="flex: 1; display: flex;">
      <ng-content></ng-content>
    </div>
  </div>